module.exports = __webpack_public_path__ + "static/based-segmentation-2-e43e5537459796212784bee09d960319.png";